import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { NotificationService, ToastNotification } from '../../service/notification.service';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],

    animations: [
        trigger('toastAnimation', [
            state('void', style({
                transform: 'translateX(100%)',
                opacity: 0
            })),
            state('active', style({
                transform: 'translateX(0)',
                opacity: 1
            })),
            state('removing', style({
                transform: 'translateX(100%)',
                opacity: 0
            })),
            transition('void => active', [
                animate('300ms ease-out')
            ]),
            transition('active => removing', [
                animate('300ms ease-in')
            ])
        ])
    ]
})
export class ToastComponent implements OnInit {
    activeToasts: (ToastNotification & { state: string })[] = [];

    constructor(private notificationService: NotificationService) {}

    ngOnInit() {
        this.notificationService.notifications$.subscribe(notification => {
            this.showToast(notification);
        });
    }

    private showToast(notification: ToastNotification) {
        const toast = { ...notification, state: 'active' };
        this.activeToasts.push(toast);

        setTimeout(() => {
            toast.state = 'removing';
            setTimeout(() => {
                this.activeToasts = this.activeToasts.filter(t => t !== toast);
            }, 300);
        }, 3000);
    }
}